import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/assets/pictos/z-0/building.png");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/assets/pictos/z-0/finger.png");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Breadcrumb/sk-Breadcrumb.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardContainer/sk-CardContainer.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/sk-Card.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardBody/sk-CardBody.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardBodyContent/sk-CardBodyContent.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardBodyHeader/sk-CardBodyHeader.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardCover/sk-CardCover.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardCoverImage/sk-CardCoverImage.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Card/components/CardFooter/sk-CardFooter.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Badge/sk-Badge.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/SeeMore/SeeMore.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Signature/sk-Signature.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/circleci/project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["InteractiveFeedback"] */ "/home/circleci/project/src/features/jobRoles/components/Details/Feedback/InteractiveFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterJobOffersLink"] */ "/home/circleci/project/src/features/jobRoles/components/Details/JobSearch/FilterJobOffersLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InteractiveJobSearch"] */ "/home/circleci/project/src/features/jobRoles/components/Details/JobSearch/InteractiveJobSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShowJobOffersLink"] */ "/home/circleci/project/src/features/jobRoles/components/Details/JobSearch/ShowJobOffersLink.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/jobRoles/components/Details/PageContent.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/careerCenter/components/SchoolBadge/SchoolBadge.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/community/components/InsightExperienceCard/InsightExperienceCard.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/company/components/CompanyCard/CompanyCard.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/jobRoles/components/Details/RelatedPages/RelatedPages.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["FollowButton"] */ "/home/circleci/project/src/modules/company/components/CompanyCard/FollowButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResultCard"] */ "/home/circleci/project/src/modules/jobSearch/components/ResultCard/ResultCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/layouts/components/Layout/Layout.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/routing/components/LinkCard.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppTrackingPageViewPropsUpdater"] */ "/home/circleci/project/src/modules/tracking/components/AppTrackingPageViewPropsUpdater.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackButtonLink"] */ "/home/circleci/project/src/modules/tracking/components/TrackButtonLink.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/tracking/components/TrackLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackObserver"] */ "/home/circleci/project/src/modules/tracking/components/TrackObserver.tsx");
